import { createFileRoute } from "@tanstack/react-router";

import { PractitionerManagePatientTemplate } from "@/uiKit/templates/PractitionerManagePatientTemplate.tsx";

export const Route = createFileRoute("/_practitioner/patients/$patientId")({
  component: PractitionerManagePatientTemplate,
});
